// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountHomepageSelectorStyles } from "@sc/Overrides/Widgets/MyAccount/MyAccountHomepageSelector";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

myAccountHomepageSelectorStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        flex: 1;
        justify-content: space-between;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

myAccountHomepageSelectorStyles.welcomeMessage = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 12px;
    `,
};

myAccountHomepageSelectorStyles.checkboxGroup = {
    css: css`
        height: 100%;
        justify-content: center;
        align-items: flex-end;
        margin-bottom: 12px;
        ${xScreen("lte", "xs")} {
            align-items: flex-start;
        }
    `,
};
